<template>
  <div>
    <div class="multiselect-wrap--small">
      <multiselect
        v-model="selectedTeams"
        track-by="id"
        label="name"
        :placeholder="$t('AUTOMATION.ACTION.TEAM_DROPDOWN_PLACEHOLDER')"
        :multiple="
          !['add_custom_attribute', 'add_contact_custom_attribute'].includes(
            action_name
          )
        "
        selected-label
        :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
        deselect-label=""
        :max-height="160"
        :options="teams"
        :allow-empty="false"
        @input="updateValue"
      />
      <textarea
        v-model="message"
        rows="4"
        :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
        @input="updateValue"
      />
    </div>
  </div>
</template>

<script>
export default {
  // The value types are dynamic, hence prop validation removed to work with our action schema
  // eslint-disable-next-line vue/require-prop-types
  props: ['teams', 'value', 'action_name'],
  data() {
    return {
      selectedTeams: [],
      message: '',
    };
  },
  mounted() {
    const { team_ids: teamIds } = this.value;
    const validTeamIds = Array.isArray(teamIds) ? teamIds : [];

    if (
      this.action_name === 'add_custom_attribute' ||
      this.action_name === 'add_contact_custom_attribute'
    ) {
      this.selectedTeams = validTeamIds.length ? validTeamIds[0] : null;
    } else {
      this.selectedTeams = validTeamIds;
    }

    this.message = this.value.message;
  },
  methods: {
    updateValue() {
      let teamIds = [];
      if (Array.isArray(this.selectedTeams)) {
        teamIds = this.selectedTeams.map(team => team.id);
      } else if (this.selectedTeams) {
        teamIds = [this.selectedTeams.id];
      }

      this.$emit('input', {
        team_ids: teamIds,
        message: this.message,
      });
    },
  },
};
</script>

<style scoped>
.multiselect {
  margin: var(--space-smaller) var(--space-zero);
}
textarea {
  margin-bottom: var(--space-zero);
}
</style>
